import request from "@/utils/request"

export function loadAd() {
    return request.post("/activity/loadAd")
}

export function inviteActivity() {
    return request.post("/activity/inviteActivity")
}